import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "onlyoffice",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_2 = {
  "element-loading-text": "正在加载文档，请稍后",
  "element-loading-background": "rgba(122, 122, 122, 0.3)",
  style: {"width":"100%","height":"100%"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, null, 512), [
      [_directive_loading, true]
    ])
  ]))
}